import { MenuConfigItem } from 'components/common/SideMenu/SideMenu';

import { WidgetSizes } from 'components/Dashboards/Reporting/reporting.types';

type ProjectConfigKey = 'create' | 'reporting' | 'confirmWidget' | 'newReport' | 'editWidget';

export const reportingConfig: Record<ProjectConfigKey, MenuConfigItem> = {
    reporting: {
        name: 'Reporting',
        title: 'Reporting Home',
        link: 'reporting',
        tooltip: '',
    },
    create: {
        name: 'Create New Report',
        title: 'Create New Report',
        link: 'create',
        tooltip: '',
    },
    confirmWidget: {
        name: 'Confirm Widget',
        title: 'Confirm Widget',
        link: 'confirm-component',
        tooltip: '',
    },
    newReport: {
        name: 'New Report',
        title: 'New Report',
        link: 'new-report',
        tooltip: '',
    },
    editWidget: {
        name: 'Edit Widget',
        title: 'Edit Widget',
        link: 'edit-component',
        tooltip: '',
    },
};

export interface ReportComponentsSize {
    w: number;
    h: number;
}

const LAYOUT_SIZES = {
    // number of columns
    COLUMN: {
        SMALL: 1,
        MEDIUM: 2,
        LARGE: 3,
    },
    // number of rows --> height = number of rows * ROW
    ROW: {
        SMALL: 3,
        MEDIUM: 6,
        LARGE: 6,
        EXTRALARGE: 9,
    },
} as const;

export const COMPONENTS_SIZES: Record<WidgetSizes, ReportComponentsSize> = {
    small: {
        w: LAYOUT_SIZES.COLUMN.SMALL,
        h: LAYOUT_SIZES.ROW.SMALL,
    },
    smallLong: {
        w: LAYOUT_SIZES.COLUMN.SMALL,
        h: LAYOUT_SIZES.ROW.MEDIUM,
    },
    mediumShort: {
        w: LAYOUT_SIZES.COLUMN.MEDIUM,
        h: LAYOUT_SIZES.ROW.SMALL,
    },
    medium: { w: LAYOUT_SIZES.COLUMN.MEDIUM, h: LAYOUT_SIZES.ROW.MEDIUM },
    largeShort: {
        w: LAYOUT_SIZES.COLUMN.LARGE,
        h: LAYOUT_SIZES.ROW.SMALL,
    },
    large: {
        w: LAYOUT_SIZES.COLUMN.LARGE,
        h: LAYOUT_SIZES.ROW.LARGE,
    },
    extraLarge: {
        w: LAYOUT_SIZES.COLUMN.LARGE,
        h: LAYOUT_SIZES.ROW.EXTRALARGE,
    },
};

export const { small, smallLong, mediumShort, medium, large, largeShort, extraLarge } = COMPONENTS_SIZES;
export const SMALL = small;
export const SMALL_LONG = smallLong;
export const MEDIUM_SHORT = mediumShort;
export const MEDIUM = medium;
export const LARGE = large;
export const LARGE_SHORT = largeShort;
export const EXTRA_LARGE = extraLarge;
